import dayjs from 'dayjs'
import 'dayjs/locale/id'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import duration from 'dayjs/plugin/duration'
import axios from 'axios'

dayjs.extend(duration)
dayjs.extend(localeData)
dayjs.extend(localizedFormat)

export function formatDate(date, format) {
  // dayjs.locale('id')
  return dayjs(date).locale('id').format(format)
}

export function getUrlFilename(url) {
  return url.substring(url.lastIndexOf('/') + 1, url.length)
}

export function downloadFile(fileUrl) {
  axios
    .get(fileUrl, { responseType: 'blob', 'Content-Disposition': 'attachment' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', getUrlFilename(fileUrl))
      document.body.appendChild(link)
      link.click()
    })
    .catch((error) => {})
}

export function formatIDR(number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(number)
}

export function getDateFromNowMonths(months = 3) {
  return dayjs().add(months, 'month').format('YYYY-MM-DD')
}
